import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MinutesToHourPipe } from './minutes-to-hours.pipe';
import { NumberArrayPipe } from './number-date.pipe';
import { DateFormatTransformPipe } from './date-format-transform.pipe';

@NgModule({
  imports: [CommonModule, DateFormatTransformPipe, MinutesToHourPipe, NumberArrayPipe],
  exports: [DateFormatTransformPipe, MinutesToHourPipe, NumberArrayPipe],
  providers: [DateFormatTransformPipe, MinutesToHourPipe, NumberArrayPipe],
})
export class DatePipesModule {}
